const map = {
	"./BuildaWord_SoundBySound_Button@2x.png": 5894,
	"./BuildaWord_WordPattern_Button@2x.png": 9969,
	"./CheckAudioButton@2x.png": 2518,
	"./Correct.wav": 9236,
	"./HaveISeenitBefore_Button@2x.png": 3761,
	"./HomeButton.png": 4165,
	"./KeepReadingButton.png": 919,
	"./RecordButton.png": 4167,
	"./RecordButton_DONE.png": 7500,
	"./RecordButton_RECORDING.png": 219,
	"./Toolbox-Closed@2x.png": 2190,
	"./Toolbox-Open@2x.png": 3230,
	"./Wrong.wav": 3081,
	"./avatar-placeholder.png": 8871,
	"./avatars/bunny.png": 7725,
	"./avatars/frog.png": 8267,
	"./avatars/howler monkey.png": 1691,
	"./avatars/lion cub.png": 4881,
	"./avatars/mouse.png": 1440,
	"./avatars/owl.png": 2319,
	"./avatars/parrot.png": 2593,
	"./avatars/piranha.png": 8272,
	"./avatars/sloth.png": 7405,
	"./avatars/toucan.png": 7175,
	"./back-arrow.png": 5237,
	"./back-button.png": 3844,
	"./badger_icon_circle-01.png": 2804,
	"./badger_record_tip.png": 9231,
	"./buddy_check.PNG": 1300,
	"./checksquare.png": 8287,
	"./next-page-button.png": 2390,
	"./onebadger.png": 7619,
	"./pick-a-book.png": 6599,
	"./read-aloud.png": 2514,
	"./slider.png": 7627,
	"./slider2.png": 8593,
	"./stars.jpg": 8221,
	"./success.mp3": 7767,
	"./threebadgers.png": 9716,
	"./totm-background.png": 8909,
	"./twobadgers.png": 6030,
	"./wall-tile.png": 5611
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;